import { ArrowDown, ArrowUpDown } from "lucide-react";

const MODES = [
  { id: "langit", title: "Langit ke Bumi", desc: "Mula dari ayat, turun jadi solusi", Icon: ArrowDown },
  { id: "bumi", title: "Bumi ke Langit ke Bumi", desc: "Mula dari isu, naik cari ayat, turun semula", Icon: ArrowUpDown },
];

export const ModeToggle = ({ mod, onChange, disabled }) => (
  <div className="grid sm:grid-cols-2 gap-3" role="radiogroup" aria-label="Mod HTE">
    {MODES.map(({ id, title, desc, Icon }) => {
      const on = mod === id;
      return (
        <button key={id} role="radio" aria-checked={on} disabled={disabled} onClick={() => onChange(id)} data-testid={`mode-${id}`}
          className={`text-left rounded-2xl p-5 min-h-[96px] border transition-[border-color,background-color,transform] duration-200 active:scale-[.99] ${on ? "border-[var(--q)] bg-q-soft" : "border-line bg-surface hover:border-[var(--mute)]"}`}>
          <div className="flex items-center gap-3">
            <span className={`h-9 w-9 rounded-full grid place-items-center border ${on ? "border-[var(--q)] text-q" : "border-line text-mute"}`}><Icon size={16} /></span>
            <span className="font-display text-lg text-ink">{title}</span>
          </div>
          <p className="text-sm text-mute mt-2 pl-12">{desc}</p>
        </button>
      );
    })}
  </div>
);
